import React from 'react'

import {
  Span,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'

// import { Container } from './styles';
interface ITableContract {
  tableData: IResponseResultGroupsItems[]
}
import { IResponseResultGroupsItems } from 'services/NGT/ReportsCRE'
import { FORMAT } from 'utils'

const TableReportCRE: React.FC<ITableContract> = ({ tableData }) => {
  const INVALID_DATE = '01/01/2001'
  return (
    <TableContainerStyled>
      <TableStyled>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled align="center">Data Verificação</TableCellStyled>
            <TableCellStyled align="center">Pendência</TableCellStyled>
            <TableCellStyled maxwidth="50px" align="center">
              Valor de risco
            </TableCellStyled>
            <TableCellStyled align="center">
              Descrição da Pendência
            </TableCellStyled>
            <TableCellStyled align="center">
              Qt Dias Criação Documento
            </TableCellStyled>
            <TableCellStyled align="center">Data Anexo</TableCellStyled>
            <TableCellStyled align="center">Data Lib</TableCellStyled>
            <TableCellStyled align="center">Matrícula Lib</TableCellStyled>
            <TableCellStyled align="center">Doc. Postado</TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          {tableData?.map((row, index) => (
            <TableRowStyled key={index}>
              <TableCellStyled align="center">
                {row.dataLiberacaoMovDocumento
                  ? FORMAT.formatMMYYYY(row.dataLiberacaoMovDocumento)
                  : '- - -'}
              </TableCellStyled>
              <TableCellStyled align="center">
                {row.tipoPendencia}
              </TableCellStyled>
              <TableCellStyled maxwidth="50px" align="center">
                {FORMAT.currency(row.vlRisco)}
              </TableCellStyled>
              <TableCellStyled align="center" wordWrap={true} style={{ paddingLeft: '40px' }} >
                {row.txPendencia ? row.txPendencia : '- - - - - - - -'}
              </TableCellStyled>
              <TableCellStyled align="center">
                {row.qtDiasCriacaoDocumento ?? '- - - - - - - -'}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FORMAT.formatDDMMYYYY(row.dtAnexo) === INVALID_DATE
                  ? '- - -'
                  : row.dtAnexo}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FORMAT.formatDDMMYYYY(row.dtLiberacao) === INVALID_DATE
                  ? '- - -'
                  : row.dtLiberacao}
              </TableCellStyled>
              <TableCellStyled align="center">
                {row.cdMatriculaItem ?? '- - - - - - - -'}
              </TableCellStyled>{' '}
              <TableCellStyled align="center">
                {row.flDocPostado ?? '- - - - - - - -'}
              </TableCellStyled>
            </TableRowStyled>
          ))}
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  )
}

export default TableReportCRE
